export default "__VITE_ASSET__BO0_KGY9__"